import { Plus } from "../../../constants/svg";
import { YellowButton } from "../../UI/Button/button";
import classes from "./card.module.css";
import { useNavigate } from "react-router";

const NewJobCard = ({ img, header, text, move }) => {
  let navigate = useNavigate();
  return (
    <div
      className={`flex ${classes.card}`}
      onClick={() => navigate(`/add-new-job/${move}`)}
    >
      <p className="center t-24">{header}</p>
      <img src={img} alt="" />
      <span className="center">{text}</span>
      <YellowButton
        extra={classes.yellowBtn}
        onClick={() => navigate(`/add-new-job/${move}`)}
      >
      <Plus />  Add a new {move}{" "}
      </YellowButton>
    </div>
  );
};

export default NewJobCard;
